<template>
    <div class="main-venue-page">
        <div class="header-venue">
            <div class="all-things">
                <div>
                    <span class="for-venue-text">For Bookers</span>
                </div>
                <div class="main-adv">
                    <p class="all-things-booking">All Things Booking, All in One Place</p>
                </div>
                <div>
                    <span class="venue-exp"
                        >Whatever your business is — dive bar, barbecue joint, microbrewery, or
                        just hosting a private event — Hedlyner has tools to help you create
                        and run an amazing live music experience.</span
                    >
                </div>
                <div class="hader-buttons">
                    <button
                        v-if="showCreateAccount"
                        @click="redirectCreateVenue"
                        class="call-to-action-venue"
                    >
                        <span class="btn-text"> Create Booker Profile </span>
                    </button>
                    <button @click="redirectAboutUs" class="call-to-exp">
                        <span class="btn-text-more">Learn More</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="calendar-venue">
            <MarketingCalendar />
            <div class="booking-adv">
                <span class="all-things-music">Booking Made Easy</span>
                <div class="divider">
                    <span class="music-exp"
                        >Our Booking Manager lets you check avails and invite artists to apply
                        for multiple events at once — then manage and advance all those events,
                        all in one place.</span
                    >
                </div>
                <div class="try-action-btn">
                    <div><span class="try-text">Try it out:</span></div>
                    <div>
                        <button @click="handleCheckAvails" class="call-to-action-venue">
                            <span class="btn-text">Check Avails</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div @mouseover="handleAnimateEventVenue" class="event-status">
            <div class="event-frame-901">
                <div>
                    <span class="all-things-music"
                        >Manage Your Events from <br />
                        Avails Check to Wrap Up</span
                    >
                </div>
                <div class="divider">
                    <span class="music-exp">
                        Manage all your events from start to finish in four easy <br />
                        steps: <span class="check-avails"> check avails</span> to invite
                        artists to apply, <span class="book-artist">book artists</span> that
                        <br />
                        fit the vibe of your show, <span class="advance">advance</span> and
                        promote your events <br />
                        using Hedlyner’s built-in marketing tools, and
                        <span class="wrap-up">wrap up</span> easily <br />
                        by automating your artist payouts in advance.
                    </span>
                </div>
            </div>
            <div class="event-venue-container">
                <EventVenue :animate="animateEventVenue" />
            </div>
        </div>
        <div class="discover-artist">
            <div class="artist-carousel"><artist-carousel /></div>
            <div class="discover-artist-text">
                <span class="all-things-music">Discover & Connect <br />with New Artists</span>
                <div class="divider">
                    <span class="music-exp">
                        Discover artists with just the right vibe for your event. Hedlyner
                        makes it easy to find the right talent… as well as explore artists’
                        music, fanbase, and social reach.
                    </span>
                </div>
            </div>
        </div>
        <div @mouseover="handleAnimateOfferCard" class="book-budget">
            <div class="budget-adv">
                <span class="all-things-music">Book on Budget</span>
                <div class="divider">
                    <span class="music-exp"
                        >Set transparent budgets for all your events, review offers <br />
                        from artists, and find that sweet spot by countering offers <br />
                        that are almost there but not quite.</span
                    >
                </div>
            </div>
            <OfferCard :animate="animateOfferCard" />
        </div>
        <div @mouseover="handleAnimateMessages" class="communicate">
            <div class="message-flow"><message-flow :animate="animateMessages" /></div>
            <div class="communicate-adv">
                <span class="all-things-music"
                    >Streamline your <br />Communication, <br />Coordination,<br />
                    Compensation…</span
                >
                <div class="divider">
                    <span class="music-exp"
                        >Take care of all your event details in one place—coordinate with
                        booked artists, build advance check-lists, set reminders, and schedule
                        automatic payouts for when the show’s over..</span
                    >
                </div>
            </div>
        </div>
        <div class="cost-flow">
            <span class="cost-header">What’s It Cost?</span>
            <span class="cost-plans"
                >Find the Hedlyner Plan that’s right for your booking needs.</span
            >
        </div>
        <div id="plans">
            <venue-sub-card
                :isAuthed="authed"
                :plans="plans"
                :currentSubscriptionPlan="currentSubscriptionPlan"
                :userHadTrial="userHadTrial"
            ></venue-sub-card>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import MarketingCalendar from './parts/MarketingCalendar.vue'
    import ArtistCarousel from './parts/ArtistCarousel.vue'
    import EventVenue from './parts/EventVenue.vue'
    import OfferCard from './parts/OfferCard.vue'
    import MessageFlow from './parts/MessageFlow.vue'
    import VenueSubCard from '../Stripe/parts/VenueSubCard.vue'
    import { useAuth } from '@/composables/auth/useAuth'

    const URLS = {
        xhr: {
            checkAuth: '/check-authorization',
            user: '/profile/v1/settings/user'
        },

        redirect: {
            createVenue: '/venues/create-new-profile',
            createVenueProfile: '/venues/create-new-profile',
            bookingManager: '/booking-manager#referred-by-marketing',
            about: '/about-us'
        }
    }

    export default {
        name: 'VenuePage',
        components: {
            MarketingCalendar,
            EventVenue,
            ArtistCarousel,
            OfferCard,
            MessageFlow,
            VenueSubCard
        },
        setup() {
            const { handleShowRegisterModal } = useAuth()

            return {
                handleShowRegisterModal
            }
        },
        data: () => ({
            authed: false,
            animateMessages: false,
            animateOfferCard: false,
            animateEventVenue: false,
            userHadTrial: false,
            userInfo: {},
            role: 'venue',
            currentSubscriptionPlan: '',
            plans: []
        }),
        methods: {
            redirectAboutUs() {
                window.location.href = this.URLS.redirect.about
            },
            redirectCreateVenue() {
                this.handleShowRegisterModal({ registerMode: 'profile' })
            },
            handleAnimateMessages() {
                this.animateMessages = true
            },
            handleAnimateEventVenue() {
                this.animateEventVenue = true
            },
            handleAnimateOfferCard() {
                this.animateOfferCard = true
            },
            handleCheckAvails() {
                if (!this.authed) {
                    this.redirectCreateVenue()
                } else if (!this.userInfo.isVenue) {
                    window.location.href = this.URLS.redirect.createVenueProfile
                } else if (this.userInfo.bookingVenue) {
                    window.location.href = this.URLS.redirect.bookingManager
                } else {
                    window.location.href = this.URLS.redirect.createVenueProfile
                }
            },
            async isAuthed() {
                try {
                    let resp = await axios.get(this.URLS.xhr.checkAuth)

                    if (resp.data.isAuthorized) {
                        this.authed = true
                    } else {
                        this.authed = false
                    }
                } catch {
                    this.authed = false
                }
            },
            async getUserSettings() {
                let resp = await axios.get(this.URLS.xhr.user)

                this.userInfo = resp.data.data[0]
            },
            async checkSub() {
                const response = await axios.get('/api/profile/stripe/get-plans')
                this.plans = response?.data?.data
            },
            async getUserPlan() {
                let response = await axios.get('/profile/stripe/user/get-plan/venue')
                this.currentSubscriptionPlan = response?.data?.subscription.plan_name
                this.userHadTrial = response?.data?.user_had_trial_period
            }
        },
        computed: {
            URLS: () => URLS,
            showCreateAccount: (self) => !(self.authed && self.userInfo.isVenue)
        },
        async created() {
            await this.isAuthed()
            if (this.authed) {
                await this.getUserSettings()
                await this.checkSub()
                await this.getUserPlan()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    @media (max-width: 600px) {
        .all-things-booking {
            font-size: 56px !important;
        }
        .main-venue-page {
            padding-left: 0 !important;
        }
        .hader-buttons {
            flex-wrap: wrap;
        }
        .call-to-action-venue {
            width: 100% !important;
        }
        .call-to-exp {
            width: 100% !important;
        }
        .all-things {
            margin-top: 100px !important;
            padding: 0 16px;
        }
        .calendar-venue {
            flex-wrap: wrap-reverse !important;
            margin-top: 0 !important;
            padding: 0 16px !important;
        }
        .booking-adv {
            flex: 0 1 100% !important;
        }
        .event-status {
            padding: 0 16px !important;
            margin-top: 150px !important;
            justify-content: center !important;
        }
        .discover-artist {
            padding: 0 16px !important;
            flex-wrap: wrap-reverse;
            flex-direction: column-reverse;
        }
        .book-budget {
            padding: 0 16px !important;
        }
        .communicate {
            padding: 0 16px !important;
        }
        .communicate-adv {
            margin-bottom: 40px !important;
        }
        .cost-flow {
            margin-right: 0 !important;
            padding: 90px 0 0 0 !important;
        }
        #plans {
            padding: 0 16px 90px 16px !important;
        }
        .artist-carousel {
            margin-top: 220px;
            flex: 0 1 52% !important;
        }
        .discover-artist-text {
            flex: 0 1 100% !important;
        }
        .header-venue {
            height: 100vh;
        }
    }
    .communicate-adv {
        flex: 0 1 35%;
    }

    .main-venue-page {
        display: flex;
        flex-direction: column;
        padding-left: 90px;
        background: #000000;
        gap: 150px;
    }

    .header-venue {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        background-image: linear-gradient(to bottom, transparent, transparent 90%, black),
            url(/images/venuepic1.png);
        background-size: 923px 848px;
        background-repeat: no-repeat;
        background-position: 100% 0%;
    }

    .all-things {
        display: flex;
        flex-direction: column;
        margin-top: 180px;
        z-index: 1;
    }

    .for-venue-text {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.2px;
    }

    .all-things-booking {
        color: #ba87ff;
        font-family: Instrument Sans;
        font-size: 72px;
        font-style: normal;
        font-weight: 525;
        line-height: 95%;
        letter-spacing: -4.32px;
        margin-bottom: 0px;
        max-width: 560px;
    }

    .venue-exp {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
    }

    .main-adv {
        margin: 20px 0;
    }

    .divider {
        margin: 15px 90px 0 0;
    }

    .main-img {
        display: flex;
        position: relative;
        overflow: hidden;
        margin-left: auto;
    }

    .hader-buttons {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-top: 30px;
        gap: 16px;
    }

    .call-to-action-venue {
        padding: 11px 50px 12px 50px;
        border-radius: 100px;
        background: #ba87ff;
        border: none;
    }

    .btn-text {
        color: #000;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }

    .call-to-exp {
        padding: 11px 50px 12px 50px;
        background: none;
        border-radius: 100px;
        border: 1px solid #ba87ff;
    }

    .btn-text-more {
        color: #ba87ff;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }

    .calendar-venue {
        align-items: center;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 70px;
        margin-top: 100px;
        justify-content: space-between;
    }

    .booking-adv {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex: 0 1 45%;
    }

    .all-things-music {
        color: #ba87ff;
        font-family: Instrument Sans;
        font-size: 44px;
        font-style: normal;
        font-weight: 550;
        line-height: 110%;
        letter-spacing: -1.76px;
    }

    .music-exp {
        color: #dedede;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }

    .try-action-btn {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .try-text {
        color: #ba87ff;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        padding-right: 15px;
    }

    .event-status {
        padding-right: 90px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 50px;
        margin-top: 150px;
        margin-bottom: 30px;
        justify-content: space-between;
        min-height: 318px;
    }
    .event-frame-901 {
        display: flex;
        flex-direction: column;
    }
    .check-avails {
        color: #cdeb09;
    }
    .book-artist {
        color: #c9cd00;
    }
    .advance {
        color: #cb9b1f;
    }
    .wrap-up {
        color: #d188bf;
    }
    .discover-artist-text {
        display: flex;
        flex-direction: column;
        flex: 0 1 40%;
    }
    .discover-artist {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: right;
    }
    .artist-carousel {
        flex: 0 1 40%;
    }
    .book-budget {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 50px;
        align-items: center;
        justify-content: space-around;
        margin-top: 150px;
        min-height: 450px;
    }
    .budget-adv {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }
    .communicate {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap-reverse;
        gap: 50px;
        align-items: flex-start;
        justify-content: space-around;
        margin-bottom: 150px;
        min-height: 550px;
    }
    .message-flow {
        display: flex;
        flex: 0 1 45%;
        max-width: 700px;
        max-height: 450px;
    }
    .cost-flow {
        padding-right: 90px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 90px;
        margin-top: 90px;
        padding: 90px 0;
        border-top: 1px solid #8b8b8b;
    }
    #plans {
        padding-right: 90px;
        padding-bottom: 90px;
        margin-left: auto;
        margin-right: auto;
    }
    .cost-header {
        color: #ba87ff;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 72px;
        font-style: normal;
        font-weight: 500;
        line-height: 100%;
        letter-spacing: -2.88px;
    }
    .cost-plans {
        color: #dedede;
        text-align: center;
        font-family: Instrument Sans;
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
</style>
